import type { TimingPayload } from "./timing";
import Timing from "./timing";

export interface DosagePayload {
  timing?: TimingPayload;
  doseQuantity?: number;
}

export default class Dosage {
  doseQuantity?: number;
  timing?: Timing;

  get jsonPayload(): DosagePayload {
    const payload: DosagePayload = {};

    if (this.timing) {
      payload.timing = this.timing.jsonPayload;
    }

    if (this.doseQuantity) {
      payload.doseQuantity = this.doseQuantity;
    }

    return payload;
  }

  /**
   * Returns true if the dosage period is more than one month (i.e. 2 months / 4 months),
   * or if "autre" dropdown possibility have been chosen.
   */
  get moreThanOneMonthOrOther(): boolean {
    if (!this.timing) return false;
    if (this.timing.period == null) return false;

    return (
      (this.timing.period > 1 && this.timing.periodUnit == "mo") ||
      !!this.timing.asNeeded ||
      !!this.timing.isOther ||
      this.timing.periodUnit == "h"
    );
  }

  constructor({
    timing,
    doseQuantity
  }: {
    timing?: Timing;
    doseQuantity?: number;
  }) {
    this.timing = timing;
    this.doseQuantity = doseQuantity;
  }

  static fromPayload(payload: DosagePayload): Dosage {
    let timing: Timing | undefined;
    let doseQuantity: number | undefined;

    if (payload.timing) {
      timing = new Timing(payload.timing);
    }

    if (payload.doseQuantity) {
      doseQuantity = parseFloat(payload.doseQuantity.toString());
    }

    return new Dosage({ timing, doseQuantity });
  }

  isEqual(other: Dosage | undefined): boolean {
    if (this == other) return true;

    let result = this.doseQuantity == other?.doseQuantity;

    if (this.timing) {
      result &&= this.timing.isEqual(other?.timing);
    }

    return result;
  }
}
